/**
 * GlobalGrainOverlay - Globalni grain texture overlay za celu aplikaciju
 * 
 * Dashboard3 noise efekat koji se primenjuje kroz celu aplikaciju.
 * Koristi animated grain texture sa smooth movement.
 * 
 * @example
 * ```tsx
 * <GlobalGrainOverlay />
 * ```
 */

"use client";

import { Box } from "@chakra-ui/react";
import { usePathname } from "next/navigation";
import { useThemeTokens } from "./hooks";
import { useDashboardTheme } from "@/components/dashboard/DashboardThemeProvider";
import { isDashboardAppearanceRoute } from "@/lib/utils/theme-scope";

export const GlobalGrainOverlay = () => {
  const theme = useThemeTokens();
  const pathname = usePathname();
  const { grainEnabled, previewGrainEnabled, effectiveDashboardAppearance } =
    useDashboardTheme();
  const effectiveGrainEnabled =
    previewGrainEnabled !== null ? previewGrainEnabled : grainEnabled;
  const isClassicDashboard =
    isDashboardAppearanceRoute(pathname) &&
    effectiveDashboardAppearance === "classic";
  const shouldShowGrain = effectiveGrainEnabled && !isClassicDashboard;

  const baseOpacity = theme.mode === "dark" ? 0.4 : 1;
  const finalOpacity = shouldShowGrain ? baseOpacity : 0;

  return (
    <Box
      position="fixed"
      inset={0}
      w="100%"
      h="100%"
      pointerEvents="none"
      zIndex={9999}
      opacity={finalOpacity}
      transition="opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
      sx={{
        background: `url("data:image/svg+xml,${encodeURIComponent(`
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
            <filter id="global-noise">
              <feTurbulence type="fractalNoise" baseFrequency="0.75" numOctaves="3" stitchTiles="stitch"/>
            </filter>
            <rect width="100%" height="100%" filter="url(#global-noise)" opacity="${theme.mode === "dark" ? "0.3" : "0.4"}"/>
          </svg>
        `)}")`,
      }}
    />
  );
};

